import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from '@ngx-translate/core';

export type GeneratedPositionDialogData = {
  numeroAvviso: string,
  pagato: boolean
}

@Component({
    selector: 'app-generated-position-modal',
    templateUrl: './generated-position-modal.component.html',
    styleUrls: ['./generated-position-modal.component.scss'],
    standalone: false
})
export class GeneratedPositionModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GeneratedPositionDialogData,
    public dialogRef: MatDialogRef<GeneratedPositionModalComponent>,
    public translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
  }

  close(result: string) {
    this.dialogRef.close(result)
  }

}
